import ClientCalendar from "./calendar/client/client-calendar";

export function CalendarPage() {
  return <ClientCalendar />;
}
